import React from "react";
import type * as stylex from "@stylexjs/stylex";
import { mergedSx } from "~/utils/stylexUtils";
type Props = Omit<React.SVGProps<SVGSVGElement>, "sx"> & {
  sx?: stylex.StyleXStyles<{
    width?: number | string;
  }>;
};

/** Renders the search icon used in issue and project lookup inputs throughout the Zendesk app. */
export const SearchIcon = (props: Props) => {
  const {
    className,
    style,
    sx,
    ...svgProps
  } = props;
  return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...svgProps} {...mergedSx(sx, className, style)}>
      <circle cx="6" cy="6" r="5" fill="none" stroke="currentColor" strokeWidth="2" />
      <path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="M15 15l-5-5" />
    </svg>;
};